import { Box, Select } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function LanguageSelect() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const switchLanguage = (lang: string) => {
    navigate(0);
    i18n.changeLanguage(lang);
  };
  return (
    <Box>
      <Select
        placeholder="Choose Language"
        w={{ base: "40", sm: "48", md: "52" }}
        size={{ base: "sm", md: "md" }}
        value={i18n.language}
        onChange={(e) => switchLanguage(e.currentTarget.value)}
      >
        <option value="en">English</option>
        <option value="fr">French</option>
      </Select>
    </Box>
  );
}
